'use strict';

angular.module('amexReconciliationApp').filter('fieldOrDashes', function () {
  return function (input) {
    return input ? input : '--';
  };
});




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/fieldOrDashes.js
// module id = 555
// module chunks = 0